import { differenceInCalendarDays, differenceInMonths, format } from 'date-fns'

export function formatPrice(amount: string | number, currency: string): string {
	const value = typeof amount === 'string' ? Number(amount) : amount
	if (Number.isNaN(value)) return '—'
	try {
		return new Intl.NumberFormat(undefined, {
			style: 'currency',
			currency,
			maximumFractionDigits: 2,
		}).format(value)
	} catch {
		return `${value.toFixed(2)} ${currency}`
	}
}

export function formatDate(date: Date | string): string {
	const d = typeof date === 'string' ? new Date(date) : date
	return format(d, 'MMM d, yyyy')
}

export type WarrantyStatus =
	| { kind: 'none' }
	| { kind: 'expired'; daysAgo: number }
	| { kind: 'expiring'; daysLeft: number }
	| { kind: 'ok'; monthsLeft: number; daysLeft: number }

export function warrantyStatus(
	expiresAt: Date | string | null,
	now: Date = new Date(),
): WarrantyStatus {
	if (!expiresAt) return { kind: 'none' }
	const exp = typeof expiresAt === 'string' ? new Date(expiresAt) : expiresAt
	const days = differenceInCalendarDays(exp, now)
	if (days < 0) return { kind: 'expired', daysAgo: -days }
	if (days <= 30) return { kind: 'expiring', daysLeft: days }
	const months = differenceInMonths(exp, now)
	return { kind: 'ok', monthsLeft: months, daysLeft: days }
}
